/**
 * @module Section-Blog-Detail-Pagination
 */

import { NavLink, useParams } from "react-router-dom";
import { TypeSectionCasePagination } from "../../@types/sectionTypes";

// Blog order for navigation (you could fetch this from an API or config)
const BLOG_ORDER = [
    "digital-transformation-churches",
    "custom-software-build-vs-buy", 
    "mobile-payment-integration",
    "cybersecurity-best-practices",
    "legacy-system-modernisation",
    "business-process-automation",
    "cloud-migration-services",
    "api-integration-guide",
    "web-development-trends-2024"
];

/**
 * 
 * @param props : Data supplied to display pagination
 * @returns Markup for blog detail pagination (previous/next blog)
 */
const SectionBlogDetailPagination = (props: {
    _paging: TypeSectionCasePagination
}) => {
    const { _paging } = props;
    const { blogId } = useParams<{ blogId: string }>();

    // Helper function to create blog detail URL with ID
    const getBlogDetailUrl = (blogId: string) => {
        return `/blog/${blogId}`;
    };

    // Generate actual blog navigation URLs based on blog order
    const getCurrentBlogIndex = () => {
        return BLOG_ORDER.findIndex(id => id === blogId);
    };
    
    const generateBlogId = (direction: 'prev' | 'next') => {
        if (!blogId) return null;
        
        const currentIndex = getCurrentBlogIndex();
        if (currentIndex === -1) return null; // Blog not found in order
        
        if (direction === 'prev') {
            return currentIndex > 0 ? BLOG_ORDER[currentIndex - 1] : null;
        } else {
            return currentIndex < BLOG_ORDER.length - 1 ? BLOG_ORDER[currentIndex + 1] : null;
        }
    };
    
    const prevBlogId = generateBlogId('prev');
    const nextBlogId = generateBlogId('next');
    const prevBlogUrl = prevBlogId ? getBlogDetailUrl(prevBlogId) : "/blog";
    const nextBlogUrl = nextBlogId ? getBlogDetailUrl(nextBlogId) : "/blog"; // Or actual next blog URL
    
    return (
        <div className="s-post-pagination-control previous-next">
            {_paging.prev && (
                <div className="paging-left paging-item">
                    <div className="paging-content">
                        <NavLink className="paging-link" to={prevBlogUrl}>
                            <i className="fa fa-long-arrow-left" />
                        </NavLink>
                        <div className="paging-content-inner">
                            <NavLink className="paging-link2" to={prevBlogUrl}>Previous Blog</NavLink>
                            <h4 className="paging-title">
                                <NavLink to={prevBlogUrl}>{_paging.prev}</NavLink>
                            </h4>
                        </div>
                    </div>
                </div>
            )}
            {_paging.next && (
                <div className="paging-right paging-item">
                    <div className="paging-content reverse">
                        <NavLink className="paging-link" to={nextBlogUrl}>
                            <i className="fa fa-long-arrow-right" />
                        </NavLink>
                        <div className="paging-content-inner">
                            <NavLink className="paging-link2" to={nextBlogUrl}>Next Blog</NavLink>
                            <h4 className="paging-title">
                                <NavLink to={nextBlogUrl}>{_paging.next}</NavLink>
                            </h4>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SectionBlogDetailPagination; 